import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DireccionService {
  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  addDireccion(data:any){
    return this.http.post(`${this.baserApiUrl}direcciones`,data)
  }
}
